export default "Écoles primaires et maternelles : confort d'été, facture énergétique et décret tertiaire. Primes CEE, Fonds vert et accompagnement des communes.";
